import React, { Fragment } from "react"
import ReactDOM from "react-dom"
import styled from "react-emotion"
import { hotkeys } from "react-keyboard-shortcuts"
class ButtonPane extends React.Component {
    state = {
        open: false,
    }
    paneRef = React.createRef()
    overlayRef = React.createRef()

    toggle = () => this.setState({ open: !this.state.open })
    close = () => {
        const pane = this.paneRef.current
        const node = ReactDOM.findDOMNode(pane)
        if (!node) return
        node.style.visibility = "visible"

        this.setState({ open: false })
    }

    // We use this to hide the pane without causing a rerender
    hide = () => {
        const component = this.paneRef.current
        const node = ReactDOM.findDOMNode(component)
        if (!node) return
        node.style.visibility = "hidden"

        const overlay = this.overlayRef.current
        const overlayNode = ReactDOM.findDOMNode(overlay)
        overlayNode.style.display = "none"
    }

    hot_keys = {
        [this.props.hotkey || "not"]: {
            // combo from mousetrap
            priority: 1,
            handler: event => this.toggle(),
        },
        esc: {
            priority: 2, // Close this menu instead of deselecting a block
            handler: event => {
                const wasOpen = this.state.open
                this.close()
                return !wasOpen
            },
        },
    }

    render() {
        return (
            <Fragment>
                <Button active={this.state.open} onClick={this.toggle}>
                    {this.props.icon}
                </Button>
                {this.state.open && (
                    <Fragment>
                        <Pane ref={this.paneRef} open={this.state.open}>
                            {this.props.children({
                                close: this.close,
                                hide: this.hide,
                            })}
                        </Pane>
                        <Overlay
                            ref={this.overlayRef}
                            open={this.state.open}
                            onClick={this.close}
                        />
                    </Fragment>
                )}
            </Fragment>
        )
    }
}

export default hotkeys(ButtonPane)

const Pane = styled("div")`
    position: fixed;
    top: 30px;
    left: ${props => (props.open ? "30px" : "-330px")};
    height: calc(100vh - 30px);
    width: 300px;
    z-index: 4;
    background-color: #23262f;
    color: #eee;
    border: #454648 1px solid;
    overflow-y: scroll;
`
const Overlay = styled("div")`
    display: ${props => (props.open ? "block" : "none")};
    position: fixed;
    top: 0px;
    left: 0px;
    height: 100vh;
    width: 100vw;
    z-index: 3;
`

const Button = styled("div")`
    color: #eee;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: #454648 1px solid;
    z-index: 3;

    &:hover {
        background-color: #111;
    }

    ${props =>
        props.active &&
        `
        background-color: #2b2f3c;
    `};
`



// WEBPACK FOOTER //
// ./src/features/editor/ui/ButtonPane.js